import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Subheading as SubheadingBase } from "components/misc/Headings.js";
import ContactUsForm from "components/forms/SimpleContactUs.js";

const Container = styled.div`
  ${tw`relative bg-brand-100 text-gray-100 -mx-8 px-8 py-10 xs:px-12 border-b-8 border-brand-500`}

  background: #01325b;
`;
const Content = tw.div`max-w-screen-xl mx-auto pt-5 pb-5`;
const TwoColumns = tw.div`flex flex-wrap justify-between items-center`;

const Column = tw.div`sm:w-full md:w-full lg:w-1/2 mb-8 md:mb-0 text-sm sm:text-base text-left md:text-left`;

const ColumnHeading = tw.h2`text-white`;
const Subheading = tw(SubheadingBase)`mb-4 text-white text-base font-normal`;
export default ({
  formheading = "German Proficiency Ampliflies Your Prospects for Studying Abroad and Build a Global Career",
  formsubheading = "Book Our Free Discussion Session Today -",
  heightlightText = "Why and When One Should Plan to Start Learning German",
  fromPage = "",
  wappAllow = true,
  formActionUrl = "",
}) => {
  return (
    <Container>
      <Content>
        <TwoColumns>
          <Column>
            <ColumnHeading>{formheading}</ColumnHeading>
            <ColumnHeading>&nbsp;</ColumnHeading>
            <Subheading>
              {" "}
              {formsubheading} <strong>{heightlightText}</strong>
            </Subheading>
            <ContactUsForm
              fromPage={fromPage}
              wapp={wappAllow}
              formActionUrl={formActionUrl}
            />
          </Column>
          <Column>
            <div tw="max-w-[680px] mx-auto text-white space-y-6">
              <h1 tw="text-5xl lg:text-5xl text-white font-bold leading-tight">
                Start Your CA Journey with the Right Guidance
              </h1>

              <p tw="text-lg text-gray-200 leading-relaxed text-justify">
                Choosing the right mentor at the beginning of your CA
                preparation can define your entire career. At{" "}
                <strong>CA Vijender Aggarwal Classes</strong>, we focus on
                building concepts, confidence, and consistency from day one.
              </p>

              <ul tw="space-y-3 text-gray-100 text-base">
                <li tw="flex items-start gap-3">
                  <span tw="text-green-400 font-bold">✔</span>
                  Concept-driven teaching from CA Intermediate to CA Final
                </li>
                <li tw="flex items-start gap-3">
                  <span tw="text-green-400 font-bold">✔</span>
                  All India Rank holder mentorship & exam-oriented strategy
                </li>
                <li tw="flex items-start gap-3">
                  <span tw="text-green-400 font-bold">✔</span>
                  Structured study plans with continuous performance tracking
                </li>
                <li tw="flex items-start gap-3">
                  <span tw="text-green-400 font-bold">✔</span>
                  Trusted by thousands of CA aspirants across India
                </li>
              </ul>

              <p tw="text-gray-300 text-sm leading-relaxed">
                Fill out the form and our academic counsellor will connect with
                you personally to guide your CA preparation roadmap.
              </p>
            </div>
          </Column>
        </TwoColumns>
      </Content>
    </Container>
  );
};
